class Case {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){


    if (window.matchMedia('(max-width: 767px)').matches) {
      const swiper = new Swiper(".case-swiper", {
        slidesPerView: 1.23,
        spaceBetween: 18,
      });
    }

    // ブレイクポイントを過ぎたらローディング
    const breakpoint = window.matchMedia("(max-width:768px)");

    breakpoint.addEventListener("change", () => {
      window.location.reload();
    });
  }
}
// globals
const e_root = document.querySelector(':root');

window.addEventListener('load', () => {
  e_root.style.setProperty('--firstViewHeight', `${window.innerHeight}px`);
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

window.addEventListener('resize', () => {
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})
class Modalhouse {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let speed = 3000;
    const modelhouse_Swiper = new Swiper('.modelhouse-Swiper', {
      loop: true,
      speed: 500,
      effect: 'fade',
      autoplay: {
        delay: speed,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          let num = index + 1;
          return (
            '<div class="' + className + ' circle-pagination' + '"><div class="circle-pagination__inner"><svg class="anime" version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 45 45"><circle class="st0 svg-elem-1" cx="22.5" cy="22.5" r="21.5" style="fill: none; stroke: rgb(255, 255, 255); stroke-width: 1px;"></circle></svg><span class="en">' + '0' + num + '</span></div></div>'
          )
        },
      },
      on: {
        slideChange: function () {
          if (this.realIndex > 0) {
            this.params.autoplay.delay = speed - 500;
          }
        },
      },
    });
  }
}
class Procedure {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // ------------------------
    // PC タブ切り替え
    // ------------------------
    $('.js-tab-trigger > div').click(function() {
      $(this).addClass('is-active');
      $(this).siblings().removeClass('is-active');

      $('.js-tab-inner > div').eq($(this).index()).siblings().css({'display':'none'});
      $('.js-tab-inner > div').eq($(this).index()).fadeIn(300);
    })

    // ------------------------
    // SP アコーディオン
    // ------------------------
    $('.js-sp-trigger').click(function() {
      $(this).toggleClass('is-active')
      $(this).next().slideToggle(500);
    })
  }
}
class System {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if (window.matchMedia('(max-width: 768px)').matches) {
        var slideCount = document.querySelectorAll('.system-swiper .swiper-slide').length;
        console.log(slideCount);
        if (slideCount > 1) {
          const swiper = new Swiper('.system-swiper', {
            speed: 500,
            loop: true,
            spaceBetween: 20,
            centeredSlides : true,
            slidesPerView:"auto",
            
            autoplay: {
              delay: 5000,
            },
          })
        }
    }

  }
}
class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    //MVアニメーション
    const mvAnimation = () => {
      let tl = gsap.timeline({repeat: 0, repeatDelay: 1});
      const mvImg = document.querySelectorAll(".js-mv__fade").length / 3 - 1

      for (let index = 0; index < mvImg; index++) {
        const num = index + 1
        tl.fromTo(`.js-mv-${num}`, 0.4,
          {
            autoAlpha: 0,

          }, {
            autoAlpha: 1,

          },
          "-=0.1"
        );
      }
      gsap.to(".js-top__fixedBnr", { autoAlpha: 1, duration: 0.3 , delay:3});
    }

    const mvTextAnimation = () => {
      let tl = gsap.timeline({repeat: 0, repeatDelay: 1});

      tl.add(textAnimation01, 1.5,);
      tl.add(textAnimation02, 1.5);
      tl.add(textAnimation01SP, 1.5);
      tl.add(textAnimation02SP, 1.5);
      tl.to(".js-mv-last ",1,{
        autoAlpha: 1,
      },
      "+=1.4")


    }



    setTimeout(mvAnimation,1200)
    setTimeout(mvTextAnimation,1000)

    function textAnimation01 () {

      const text01 = document.querySelector(".js-strip-01")

      text01.classList.add("is-show")
    }

    function textAnimation02 () {
    setTimeout(() => {
        const text02 = document.querySelector(".js-strip-02")
        text02.classList.add("is-show")
      }, 200);
    }

    function textAnimation01SP () {

      const text01 = document.querySelector(".js-strip-01-sp")

      text01.classList.add("is-show")
    }

    function textAnimation02SP () {
    setTimeout(() => {
        const text02 = document.querySelector(".js-strip-02-sp")
        text02.classList.add("is-show")
      }, 200);
    }

    //固定バナーの表示制御
    const fixedBnr = document.querySelector(".js-top__fixedBnr")
    const bodyHeight = document.querySelector(".l-main").clientHeight;
    const footerHeight = document.querySelector(".l-footer").clientHeight;

    if (window.matchMedia('(max-width: 768px)').matches) {
      scrollFade(1800)
    }else{
      scrollFade(2500)
    }

    function  scrollFade (num) {

      window.addEventListener('scroll', (event) => {
        let scroll_y = window.scrollY;

        if(scroll_y > bodyHeight -  footerHeight - num){
          fixedBnr.classList.add("is-fade")
        }else{
          fixedBnr.classList.remove("is-fade")
        }

      });
      // window.addEventListener('resize', (event) => {
      //   location.reload();
      // });
    }

    // 施工事例　スライダー
    $(function(){
      $('.s-top-case').slick({
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>',
        autoplay: true,
        adaptiveHeight: true,
        centerMode: true,
        centerPadding: "10%",
        dots: false,
        variableWidth: true,
        pauseOnFocus: false,
        pauseOnHover: false,
      });
    });

    // MVテキスト分割
      const texts = document.querySelectorAll('.text-sprit');

      texts.forEach((text) => {
        let html = '';
        const strs = text.textContent.split('');

        strs.forEach((str) => {
          const replacedStr = str.replace(/\s|&nbsp;/g, '&nbsp;');
          html += `<span>${replacedStr}</span>`;
        });
        text.innerHTML = html;
      });



    // ブレイクポイントを過ぎたらローディング
    const breakpoint = window.matchMedia("(max-width:768px)");

    breakpoint.addEventListener("change", () => {
      window.location.reload();
    });

  }
}
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).parent().parent().parent().next().addClass('c-accordion__inner').css({'display': 'none'});
    $("." + this.el).parent().parent().parent().parent().addClass('c-accordion__wrap')

    $("." + this.el).on('click', function() {
      $(this).toggleClass('is-active');
      $(this).parent().parent().parent().next().slideToggle();
    })
  }
}
class Editor {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    $('.c-editor p, .c-editor div').each(function(index, el) {
      if(el.textContent == ' ' || el.textContent == '') {
        el.style.height = '1px';
        el.style.marginTop = '1.5rem';
      }
    })

    $('[class*="wp-image"]').each(function(index, el) {
      el.style.width = Number(el.offsetWidth) * 0.1 + 'rem';
      el.style.height = 'auto';
    })

  }
}
class Loading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const body = document.getElementsByTagName('body')[0];
    const btn = document.getElementById('btn');
    let scrollTop = 0;
    
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('no_scroll');
    
    setTimeout(() => {
      $(".c-loading").fadeOut(500);
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    }, 800);
  }
}
class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-modal-inner').parent().clone().insertBefore('.c-modal .c-modal-clone');

    $('main .c-modal-inner').parent().remove();

    const body = document.getElementsByTagName('body')[0];
    let scrollTop = 0;

    $(".c-modal-inner").parent().addClass('u-mt-0');

    $(".c-modal-trigger").on("click", function() {
      $(`#${$(this).data('id')}, .c-modal-overlay`).addClass('is-active');

      scrollTop = window.scrollY;
      body.style.top = (scrollTop * -1) + 'px';
      body.classList.add('no_scroll');

      return false;
    })

    $(".c-modal-close, .c-modal-overlay").on("click", function() {
      $(`.c-modal-inner, .c-modal-overlay`).removeClass('is-active');
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    })
  }
}
class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.c-swiper', {
      speed: 500,
      loop: true,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })

  }
}

class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-tab-trigger').parent().parent().parent().addClass('u-mb-0');
    $(".c-tab-inner").parent().addClass('c-tab-wrap');
    $(".c-tab-wrap").eq(0).css({'display': 'block'});

    $(".c-tab-trigger li").on('click', function() {
      let el_num = $(this).index();
      $(".c-tab-trigger li").removeClass('is-active');
      $(this).addClass('is-active');

      $('.c-tab-wrap').css({'display': 'none'});
      $('.c-tab-wrap').eq(el_num).css({'display': 'block'});
    })
  }
}
class CaseSlider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    // 施工事例　スライダー
    $('.s-top-case').slick({
      prevArrow: '<button class="slide-arrow prev-arrow"></button>',
      nextArrow: '<button class="slide-arrow next-arrow"></button>',
      autoplay: true,
      adaptiveHeight: true,
      centerMode: true,
      centerPadding: "10%",
      dots: false,
      variableWidth: true,
      pauseOnFocus: false,
      pauseOnHover: false,
    });
  }
}
class CatList {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(function(){
      //クリックで動く
      $('.js-cat-open .cat-list-title').click(function(){
        $(this).parent().toggleClass("is-active")
        $(this).next().slideToggle();
        $(this).find('svg').toggleClass('open');
      });
    });
  }
}
//noScroll
class Common {
  constructor(el,opt){
    this.event();
  }
  event(){

    // ヘッダー メガメニュー
    $('.js-h-mega').hover(
      function (){
        $('.js-hamNameOverlay').addClass('is-active');
        $('.js-hamNameOverlay').css({'z-index': '351'});
        $(this).css({'z-index': '352'});
      },
      function () {
        $('.js-hamNameOverlay').removeClass('is-active');
        $(this).css({'pointerEvents': 'none'});
        setTimeout(() => {
          $('.js-hamNameOverlay').css({'z-index': '200'});
          $(this).css({'z-index': '1'});
          $(this).css({'pointerEvents': 'inherit'});
        }, 300);
      }
    );

    // 追従メニュー フッター到達時非表示
    let options = {
      threshold: [0]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.intersectionRatio > 0) {
          $('.js-top__fixedBnr').addClass('is-hidden');
        } else {
          $('.js-top__fixedBnr').removeClass('is-hidden');
        }
      });
    }, options);

    let el = document.querySelector('.js-footer')
    observerEnter.observe(el);

    new ScrollHint('.js-scrollable', {
      i18n: {
        scrollable: 'スクロールできます',
      },
      suggestiveShadow: true
    });

  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class HamMenu {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const hamTrigger = document.querySelector(".js-hamNameTrigger")
    const hamContainer = document.querySelector(".js-hamNameContainer")
    const hamOverlay = document.querySelector(".js-hamNameOverlay")
    const body = document.querySelector("body")

    hamTrigger.addEventListener("click", () => {
      hamTrigger.classList.toggle("is-active")
      hamContainer.classList.toggle("is-open")
      hamOverlay.classList.toggle("is-active")
      body.classList.toggle("is-fixed")
    })
    hamOverlay.addEventListener("click", () => {
      hamTrigger.classList.toggle("is-active")
      hamContainer.classList.toggle("is-open")
      hamOverlay.classList.toggle("is-active")
      body.classList.toggle("is-fixed")
    })
  }
}
//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class ModalSlider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

  const modal = document.getElementById("modal");
  const openModalBtns = document.querySelectorAll(".js-open-modal");
  const closeModalBtns = document.querySelectorAll(".js-close-modal");
  const body = document.querySelector("body")

  const swiper = new Swiper(".swiper", {
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
  },
    spaceBetween: 30,
  });

  // モーダルを表示するボタンをクリックしたとき
  openModalBtns.forEach((openModalBtn) => {
    openModalBtn.addEventListener("click", () => {
      // data-slide-indexに設定したスライド番号を取得
      const modalIndex = openModalBtn.dataset.slideIndex;
      swiper.slideTo(modalIndex);
      modal.classList.add("is-active");
      body.classList.add("is-fixed")
    });
  });

  // モーダルを閉じるボタンをクリックしたとき
  closeModalBtns.forEach((closeModalBtn) => {
    closeModalBtn.addEventListener("click", () => {
      modal.classList.remove("is-active");
      body.classList.remove("is-fixed")
    });
  });

  }
}
class OriginalSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if (window.matchMedia('(max-width: 767px)').matches) {
      const swiper = new Swiper('.case-og-swiper', {
        speed: 500,
        loop: true,
        spaceBetween: 30,
        slidesPerView: "auto",
        autoplay: {
          delay: 2000,
        },
      })
    }
  }
}
//noScroll
class ScrollEl {
  constructor(el,opt){
    this.el = $("." + el);
    if(this.el.length > 0){
      this.event();
    }
  }
  event(){

    gsap.to(".js-scrollMv", 
    {
      ease: "power1.out",
      scrollTrigger: {
        trigger: ".js-scrollMv",
        start: () => `0px`,
        end: () => `800px`,
        pin: true,
        // markers: true
      }
    })

    gsap.to(".js-scrollMv-hidden", 
    {
      opacity: 0,
      ease: "power1.out",
      scrollTrigger: {
        trigger: ".js-scrollMv-trigger",
        start: () => `100px`,
        end: () => `300px`,
        scrub: 0.1,
        // markers: true
      }
    })

    gsap.to(".js-scrollMv-text, .js-scrollMv-bg", 
    {
      opacity: 1,
      ease: "power1.out",
      scrollTrigger: {
        trigger: ".js-scrollMv-trigger",
        start: () => `300px`,
        end: () => `500px`,
        scrub: 0.1,
        // markers: true
      }
    })
  }
}


(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let common = new Common();
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let top = new Top('p-top');
  let procedure = new Procedure('p-procedure');
  let modalhouse = new Modalhouse('p-modelhouse');
  let cases = new Case('js-case');
  let hamMenu = new HamMenu('js-ham');
  let modalSlider = new ModalSlider('js-modalSlider');
  let caseSlider = new CaseSlider('js-caseSlider');
  let system = new System('p-system');
  let originalSwiper = new OriginalSwiper('js-swiper-og');
  let scrollEl = new ScrollEl('js-scrollMv');



  // 以下ページビルダー用
  let accordion = new Accordion('c-accordion');
  let modal = new Modal('c-modal-trigger');
  let tab = new Tab('c-tab-trigger');
  let swiper = new Slider('c-swiper');
  let loading = new Loading('c-loading');
  let editor = new Editor();
  let catList = new CatList('js-cat-open');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });